import { render, staticRenderFns } from "./PopupRegisterGift.vue?vue&type=template&id=093b7d24&scoped=true&"
import script from "./PopupRegisterGift.vue?vue&type=script&lang=js&"
export * from "./PopupRegisterGift.vue?vue&type=script&lang=js&"
import style0 from "./PopupRegisterGift.vue?vue&type=style&index=0&id=093b7d24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b7d24",
  null
  
)

export default component.exports